import React from "react";
import { useNavigate } from "react-router-dom";
import "./RefundPolicy.css";

const RefundPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="container py-5 refund-policy">
      <div className="mb-4">
        <button
          className="btn btn-outline-primary"
          onClick={() => navigate("/")}
        >
          ⟵ Back to Home
        </button>
      </div>
      
      <h2 className="text-center fw-bold mb-4">Refund Policy</h2>

      <h5 className="fw-bold mt-4">1. Non-Refundable Subscriptions</h5>
      <ul>
        <li>
          All subscription fees are <strong>non-refundable</strong>.
        </li>
        <li>
          No refunds will be given once the website setup begins (domain, admin
          panel, or hosting initiated).
        </li>
      </ul>

      <h5 className="fw-bold mt-4">2. Annual Billing Commitment</h5>
      <ul>
        <li>
          Services are <strong>prepaid for one full year</strong>.
        </li>
        <li>
          Cancellation or inactivity does not entitle the user to any refund.
        </li>
      </ul>

      <h5 className="fw-bold mt-4">3. Exceptions</h5>
      <p>Refunds will only be considered for the following reasons:</p>
      <ul>
        <li>Duplicate payments</li>
        <li>
          Billing errors <strong>proven to be caused by our system</strong>
        </li>
      </ul>

      <h5 className="fw-bold mt-4">4. Request Process</h5>
      <p>
        Submit refund exception requests to:
        <br />
        <strong>Email:</strong>{" "}
        <a href="mailto:info@lagran.in">info@lagran.in</a>
        <br />
        <strong>Phone:</strong> <a href="tel:+918978465525">+91-8978465525</a>
      </p>
      <p>
        Please include <strong>transaction details</strong> and a brief reason
        for your request.
      </p>

      <h5 className="fw-bold mt-4">5. Refund Timeline</h5>
      <ul>
        <li>
          Approved refunds (for exceptions only) will be processed within{" "}
          <strong>7–10 business days</strong>.
        </li>
      </ul>

      <h5 className="fw-bold mt-4">6. Policy Amendments</h5>
      <ul>
        <li>
          We reserve the right to update or modify this policy at any time
          without prior notice.
        </li>
      </ul>

      <p className="mt-4">
        <strong>
          By subscribing to our service, you agree to the terms of this Refund
          Policy.
        </strong>
      </p>
    </div>
  );
};

export default RefundPolicy;
